// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2ixNF","title":"AfterBackImages_title__FDkCl","images":"AfterBackImages_images__pHLLV"};